var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Icon } from "../../UI";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { tocGenerationActions } from "./actions";






const mapDispatchToProps = (dispatch) =>
bindActionCreators({ onClick: tocGenerationActions.reviewToc }, dispatch);

const connector = connect(null, mapDispatchToProps);




const ReviewTocButton = ({ file, onClick, children }) => /*#__PURE__*/
_jsx(FeatureToggle, { feature: "tocGeneration" }, void 0,
file.generatedToc && /*#__PURE__*/
_jsx("button", { type: "button", onClick: () => onClick(file._id), className: "edit-toc btn btn-success" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "tasks" }), /*#__PURE__*/
_jsx("span", { className: "btn-label" }, void 0, children)
)

);


const container = connector(ReviewTocButton);
export { container as ReviewTocButton };